import { useState, useEffect } from 'react'
import { useMobile } from '../hooks/useMobile'
import api from '../services/api'

const SLUG = 'santarosa'

const SBG = { aberto:'#E6F1FB', tramitando:'#FAEEDA', pendente:'#fef9c3', concluido:'#EAF3DE', arquivado:'#F1EFE8' }
const SC  = { aberto:'#185FA5', tramitando:'#854F0B', pendente:'#854d0e', concluido:'#3B6D11', arquivado:'#5F5E5A' }
const SL  = { aberto:'Aguardando', tramitando:'Em andamento', pendente:'⚠️ Docs pendentes', concluido:'✅ Concluído', arquivado:'Arquivado' }
const IT  = { despacho:'💬', tramitacao:'➡️', pendencia:'⚠️', conclusao:'✅', arquivamento:'📦', abertura:'📂' }
const CLS = {
  obrigatorio: { label:'Obrigatório', bg:'#FCEBEB', cor:'#791F1F' },
  recomendado: { label:'Recomendado', bg:'#FAEEDA', cor:'#633806' },
  opcional:    { label:'Opcional',    bg:'#F1EFE8', cor:'#444441' },
}

export default function PortalServidor() {
  const isMobile = useMobile()
  const [tela, setTela] = useState('login')
  const [servidor, setServidor] = useState(null)
  const [processos, setProcessos] = useState([])
  const [tipos, setTipos] = useState([])
  const [tipoSel, setTipoSel] = useState(null)
  const [campos, setCampos] = useState([])
  const [docsTipo, setDocsTipo] = useState([])
  const [respostas, setRespostas] = useState({})
  const [arquivosPorDoc, setArquivosPorDoc] = useState({})
  const [termoAceito, setTermoAceito] = useState(false)
  const [processoAtivo, setProcessoAtivo] = useState(null)
  const [docs, setDocs] = useState([])
  const [abaDetalhe, setAbaDetalhe] = useState('andamento')
  const [form, setForm] = useState({})
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState('')
  const [load, setLoad] = useState(false)
  const [trocarSenha, setTrocarSenha] = useState(false)
  const [solicitandoSenha, setSolicitandoSenha] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem('pg_srv_token')
    const user = localStorage.getItem('pg_srv_user')
    if (token && user) { setServidor(JSON.parse(user)); setTela('home'); carregarProcessos() }
    api.get(`/tipos/publico/${SLUG}`, { params: { portal:'servidor' } }).then(r => setTipos(r.data)).catch(() => {})
  }, [])

  async function carregarProcessos() {
    try {
      const srv = JSON.parse(localStorage.getItem('pg_srv_user') || '{}')
      const r = await api.get('/processos', { params: { req_email: srv.email, limite: 50 } })
      setProcessos(r.data?.processos || [])
    } catch {}
  }

  async function selecionarTipo(t) {
    setTipoSel(t); setCampos([]); setDocsTipo([]); setRespostas({}); setArquivosPorDoc({}); setTermoAceito(false)
    const [c, d] = await Promise.all([
      api.get(`/formulario/${t.id}`).then(r => r.data).catch(() => []),
      api.get(`/documentos-tipo/${t.id}`).then(r => r.data).catch(() => []),
    ])
    setCampos(c); setDocsTipo(d)
  }

  const set = (k,v) => setForm(f => ({...f,[k]:v}))

  async function fazerLogin(e) {
    e.preventDefault(); setErro(''); setLoad(true)
    try {
      const r = await api.post('/auth/login-servidor', { email:form.email, senha:form.senha, prefeitura_slug:SLUG })
      localStorage.setItem('pg_srv_token', r.data.token)
      localStorage.setItem('pg_srv_user', JSON.stringify(r.data.servidor))
      localStorage.setItem('pg_token', r.data.token)
      localStorage.setItem('pg_usuario', JSON.stringify({ ...r.data.servidor, prefeitura_slug: SLUG }))
      setServidor(r.data.servidor)
      if (r.data.trocar_senha) { setTrocarSenha(true); setTela('trocar_senha') }
      else { setTela('home'); carregarProcessos() }
      setForm({})
    } catch(e) { setErro(e.response?.data?.erro || 'E-mail ou senha inválidos') }
    finally { setLoad(false) }
  }

  async function fazerTrocarSenha(e) {
    e.preventDefault(); setErro('')
    if (form.nova_senha !== form.confirmar_senha) { setErro('As senhas não coincidem'); return }
    if (form.nova_senha?.length < 6) { setErro('A senha deve ter pelo menos 6 caracteres'); return }
    setLoad(true)
    try {
      await api.put('/usuarios/perfil/alterar-senha', { senha_atual: form.senha_atual, nova_senha: form.nova_senha })
      setSucesso('Senha alterada!'); setTrocarSenha(false); setForm({}); setTela('home'); carregarProcessos()
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao alterar senha') }
    finally { setLoad(false) }
  }

  async function solicitarSenha(e) {
    e.preventDefault(); setErro(''); setLoad(true)
    try {
      await api.post('/usuarios/solicitar-senha', { email:form.email_recuperar, prefeitura_slug:SLUG })
      setSucesso('Solicitação enviada! Aguarde o administrador.'); setSolicitandoSenha(false); setForm({})
      setTimeout(() => setSucesso(''), 6000)
    } catch(e) { setErro(e.response?.data?.erro || 'E-mail não encontrado') }
    finally { setLoad(false) }
  }

  async function verDetalhe(p) {
    setProcessoAtivo(p); setDocs([]); setAbaDetalhe('andamento'); setTela('detalhe')
    try {
      const r = await api.get(`/processos/${p.id}`)
      setProcessoAtivo(r.data)
      const rd = await api.get(`/documentos/${p.id}`).catch(() => ({ data:[] }))
      setDocs(rd.data||[])
    } catch {}
  }

  async function abrirSolicitacao(e) {
    e.preventDefault(); setErro('')
    const faltando = docsTipo.filter(d => d.classificacao==='obrigatorio' && !arquivosPorDoc[d.id])
    if (faltando.length > 0) { setErro(`Anexe: ${faltando.map(d=>d.nome).join(', ')}`); return }
    if (tipoSel?.termo_declaracao && !termoAceito) { setErro('Aceite o termo para continuar.'); return }
    setLoad(true)
    try {
      const dadosFormulario = {}
      campos.forEach(c => { if(respostas[c.id]) dadosFormulario[c.label] = respostas[c.id] })
      const res = await api.post('/processos', {
        tipo_id: tipoSel?.id, assunto: tipoSel?.nome || form.assunto,
        dados_formulario: dadosFormulario, req_nome: servidor.nome, req_email: servidor.email,
        setor_destino_id: tipoSel?.setor_destino_id
      })
      const processo = res.data
      for (const [docTipoId, arquivo] of Object.entries(arquivosPorDoc)) {
        const fd = new FormData(); fd.append('arquivo', arquivo); fd.append('visibilidade','restrito'); fd.append('documento_tipo_id', docTipoId)
        try { await api.post(`/documentos/upload/${processo.id}`, fd, { headers:{'Content-Type':'multipart/form-data'} }) } catch {}
      }
      setSucesso('Solicitação enviada!'); setTela('home'); carregarProcessos()
      setTipoSel(null); setCampos([]); setDocsTipo([]); setRespostas({}); setArquivosPorDoc({}); setTermoAceito(false); setForm({})
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao abrir solicitação') }
    finally { setLoad(false) }
  }

  function sair() {
    localStorage.removeItem('pg_srv_token'); localStorage.removeItem('pg_srv_user')
    setServidor(null); setTela('login'); setForm({})
  }

  function renderCampo(campo) {
    const val = respostas[campo.id]||''
    const setVal = v => setRespostas(r => ({...r,[campo.id]:v}))
    const style = { width:'100%', padding:'12px 14px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, boxSizing:'border-box' }
    if(campo.tipo_campo==='select') {
      const opcoes = Array.isArray(campo.opcoes)?campo.opcoes:JSON.parse(campo.opcoes||'[]')
      return <select value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} style={style}>
        <option value="">Selecione...</option>
        {opcoes.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    }
    if(campo.tipo_campo==='textarea') return <textarea value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} placeholder={campo.placeholder||''} style={{...style,minHeight:90,resize:'vertical'}} />
    if(campo.tipo_campo==='checkbox') return <label style={{ display:'flex', alignItems:'center', gap:10, fontSize:14 }}><input type="checkbox" checked={!!val} onChange={e=>setVal(e.target.checked?'sim':'')} style={{ width:20, height:20 }} />{campo.placeholder||'Sim'}</label>
    return <input type={campo.tipo_campo||'text'} value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} placeholder={campo.placeholder||''} style={style} />
  }

  const p = isMobile ? 16 : 24
  const inpStyle = { width:'100%', padding:'12px 14px', border:'1px solid #d1d5db', borderRadius:10, fontSize:15, boxSizing:'border-box', WebkitAppearance:'none' }

  const wrap = children => (
    <div style={{ minHeight:'100vh', background:'#f0f4f8', fontFamily:'system-ui,sans-serif' }}>
      {servidor && tela!=='login' && tela!=='trocar_senha' && (
        <div style={{ background:'#185FA5', padding:`12px ${p}px`, display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:10 }}>
          <div style={{ color:'white', fontWeight:600, fontSize:15 }}>Proto<span style={{ color:'#B5D4F4' }}>Gov</span> <span style={{ fontWeight:400, fontSize:12, color:'#B5D4F4' }}>· Servidor</span></div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ color:'#B5D4F4', fontSize:13 }}>{servidor.nome?.split(' ')[0]}</span>
            {tela!=='home' && <button onClick={() => setTela('home')} style={{ padding:'5px 10px', background:'rgba(255,255,255,0.15)', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer' }}>← Início</button>}
            <button onClick={sair} style={{ padding:'5px 10px', background:'rgba(255,255,255,0.15)', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer' }}>Sair</button>
          </div>
        </div>
      )}
      <div style={{ maxWidth:680, margin:'0 auto', padding:`${p}px ${p}px` }}>
        {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}
        {children}
      </div>
    </div>
  )

  // LOGIN
  if(tela==='login') return wrap(
    <div style={{ maxWidth:420, margin:'0 auto', paddingTop:isMobile?8:40 }}>
      <div style={{ textAlign:'center', marginBottom:24 }}>
        <div style={{ fontSize:26, fontWeight:700, color:'#185FA5' }}>ProtoGov</div>
        <div style={{ fontSize:14, color:'#6b7280', marginTop:4 }}>Portal do Servidor</div>
      </div>
      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:isMobile?20:28 }}>
        {!solicitandoSenha ? (
          <form onSubmit={fazerLogin}>
            {[['email','E-mail funcional','seu@prefeitura.gov.br','email'],['senha','Senha','••••••••','password']].map(([k,l,ph,t])=>(
              <div key={k} style={{ marginBottom:16 }}>
                <label style={{ display:'block', fontSize:13, fontWeight:500, marginBottom:6, color:'#374151' }}>{l}</label>
                <input type={t} value={form[k]||''} onChange={e=>set(k,e.target.value)} required placeholder={ph} style={inpStyle} />
              </div>
            ))}
            {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626', marginBottom:14 }}>{erro}</div>}
            <button type="submit" disabled={load} style={{ width:'100%', padding:14, background:'#185FA5', color:'white', border:'none', borderRadius:10, fontSize:16, cursor:'pointer', fontWeight:500 }}>
              {load?'Entrando...':'Entrar'}
            </button>
            <button type="button" onClick={() => { setSolicitandoSenha(true); setErro(''); setForm({}) }}
              style={{ width:'100%', padding:12, background:'white', color:'#6b7280', border:'none', fontSize:14, cursor:'pointer', marginTop:10, textDecoration:'underline' }}>
              Esqueci minha senha
            </button>
          </form>
        ) : (
          <form onSubmit={solicitarSenha}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:4 }}>Solicitar senha provisória</div>
            <div style={{ fontSize:13, color:'#9ca3af', marginBottom:16 }}>O administrador será notificado.</div>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:13, fontWeight:500, marginBottom:6, color:'#374151' }}>Seu e-mail funcional</label>
              <input type="email" value={form.email_recuperar||''} onChange={e=>set('email_recuperar',e.target.value)} required placeholder="seu@prefeitura.gov.br" style={inpStyle} />
            </div>
            {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626', marginBottom:14 }}>{erro}</div>}
            <button type="submit" disabled={load} style={{ width:'100%', padding:14, background:'#185FA5', color:'white', border:'none', borderRadius:10, fontSize:16, cursor:'pointer', fontWeight:500 }}>
              {load?'Enviando...':'Solicitar senha'}
            </button>
            <button type="button" onClick={() => { setSolicitandoSenha(false); setErro(''); setForm({}) }}
              style={{ width:'100%', padding:12, background:'white', color:'#6b7280', border:'none', fontSize:14, cursor:'pointer', marginTop:10, textDecoration:'underline' }}>
              Voltar ao login
            </button>
          </form>
        )}
      </div>
    </div>
  )

  // TROCAR SENHA
  if(tela==='trocar_senha') return wrap(
    <div style={{ maxWidth:420, margin:'0 auto', paddingTop:isMobile?8:40 }}>
      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:isMobile?20:28 }}>
        <div style={{ fontSize:16, fontWeight:600, marginBottom:4 }}>🔑 Troca de senha obrigatória</div>
        <div style={{ fontSize:13, color:'#6b7280', marginBottom:20 }}>Você está usando uma senha provisória. Defina uma nova senha agora.</div>
        <form onSubmit={fazerTrocarSenha}>
          {[['senha_atual','Senha provisória atual'],['nova_senha','Nova senha (mín. 6 caracteres)'],['confirmar_senha','Confirmar nova senha']].map(([k,l])=>(
            <div key={k} style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:13, fontWeight:500, marginBottom:6, color:'#374151' }}>{l}</label>
              <input type="password" value={form[k]||''} onChange={e=>set(k,e.target.value)} required style={inpStyle} />
            </div>
          ))}
          {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626', marginBottom:14 }}>{erro}</div>}
          <button type="submit" disabled={load} style={{ width:'100%', padding:14, background:'#185FA5', color:'white', border:'none', borderRadius:10, fontSize:16, cursor:'pointer', fontWeight:500 }}>
            {load?'Salvando...':'Definir nova senha'}
          </button>
        </form>
      </div>
    </div>
  )

  // NOVO
  if(tela==='novo') return wrap(
    <form onSubmit={abrirSolicitacao}>
      <div style={{ fontSize:16, fontWeight:500, marginBottom:4 }}>Nova solicitação</div>
      <div style={{ fontSize:13, color:'#9ca3af', marginBottom:16 }}>Selecione o tipo</div>
      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {tipos.map(t => (
            <div key={t.id} onClick={() => selecionarTipo(t)} style={{ border:`2px solid ${tipoSel?.id===t.id?'#185FA5':'#e5e7eb'}`, borderRadius:10, padding:'12px 14px', cursor:'pointer', background:tipoSel?.id===t.id?'#E6F1FB':'white' }}>
              <div style={{ fontSize:14, fontWeight:500, color:tipoSel?.id===t.id?'#185FA5':'#111' }}>{t.nome}</div>
              {t.descricao && <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>{t.descricao}</div>}
              {t.prazo_dias && <div style={{ fontSize:12, color:'#6b7280', marginTop:3 }}>⏱ {t.prazo_dias} dias</div>}
            </div>
          ))}
        </div>
      </div>

      {tipoSel && <>
        {campos.length > 0 && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
            {campos.map(c => (
              <div key={c.id} style={{ marginBottom:16 }}>
                <label style={{ display:'block', fontSize:13, fontWeight:500, marginBottom:6, color:'#374151' }}>
                  {c.label}{c.obrigatorio && <span style={{ color:'#dc2626' }}> *</span>}
                </label>
                {renderCampo(c)}
              </div>
            ))}
          </div>
        )}

        {docsTipo.length > 0 && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden', marginBottom:16 }}>
            <div style={{ padding:'14px 16px', borderBottom:'1px solid #f3f4f6', fontSize:13, fontWeight:500 }}>📎 Documentos</div>
            {docsTipo.map((d,i) => {
              const cls = CLS[d.classificacao]||CLS.obrigatorio
              const arquivo = arquivosPorDoc[d.id]
              return (
                <div key={d.id} style={{ padding:'14px 16px', borderBottom:i<docsTipo.length-1?'1px solid #f9fafb':'none' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
                    {arquivo
                      ? <div style={{ width:22, height:22, borderRadius:'50%', background:'#EAF3DE', border:'2px solid #3B6D11', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, color:'#3B6D11', flexShrink:0 }}>✓</div>
                      : <div style={{ width:22, height:22, borderRadius:'50%', border:`2px solid ${d.classificacao==='obrigatorio'?'#fecaca':'#d1d5db'}`, background:'white', flexShrink:0 }} />
                    }
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:14, fontWeight:500 }}>{d.nome}</div>
                      <span style={{ background:cls.bg, color:cls.cor, fontSize:11, padding:'1px 7px', borderRadius:99 }}>{cls.label}</span>
                    </div>
                  </div>
                  {d.observacao && <div style={{ fontSize:13, color:'#6b7280', marginBottom:8, paddingLeft:32 }}>💡 {d.observacao}</div>}
                  <div style={{ paddingLeft:32 }}>
                    {arquivo ? (
                      <div style={{ display:'flex', alignItems:'center', gap:8, background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:'8px 12px' }}>
                        <span style={{ fontSize:13, color:'#15803d', flex:1 }}>✅ {arquivo.name}</span>
                        <button type="button" onClick={() => setArquivosPorDoc(a => { const n={...a}; delete n[d.id]; return n })} style={{ background:'none', border:'none', color:'#dc2626', cursor:'pointer', padding:'4px 8px' }}>Remover</button>
                      </div>
                    ) : (
                      <button type="button" onClick={() => { const i=document.createElement('input');i.type='file';i.accept='.pdf,.jpg,.jpeg,.png';i.onchange=e=>{if(e.target.files[0])setArquivosPorDoc(a=>({...a,[d.id]:e.target.files[0]}))};i.click() }}
                        style={{ width:'100%', padding:'10px', border:`1.5px dashed ${d.classificacao==='obrigatorio'?'#fca5a5':'#d1d5db'}`, borderRadius:8, fontSize:14, cursor:'pointer', background:'#fafafa' }}>
                        📎 Anexar documento
                      </button>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {tipoSel.termo_declaracao && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:10 }}>{tipoSel.termo_titulo||'Termo'}</div>
            <div style={{ background:'#f9fafb', borderRadius:8, padding:14, fontSize:13, lineHeight:1.7, marginBottom:14, maxHeight:180, overflowY:'auto', border:'1px solid #e5e7eb' }}>{tipoSel.termo_declaracao}</div>
            <label style={{ display:'flex', alignItems:'flex-start', gap:12, cursor:'pointer' }}>
              <input type="checkbox" checked={termoAceito} onChange={e=>setTermoAceito(e.target.checked)} style={{ width:22, height:22, marginTop:2, flexShrink:0 }} />
              <span style={{ fontSize:14, lineHeight:1.5 }}>Li e concordo com os termos acima.</span>
            </label>
          </div>
        )}

        {campos.length === 0 && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:500, marginBottom:8 }}>Descrição *</label>
            <textarea value={form.assunto||''} onChange={e=>set('assunto',e.target.value)} required placeholder="Descreva sua solicitação..."
              style={{ width:'100%', padding:'12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, minHeight:100, resize:'vertical', boxSizing:'border-box' }} />
          </div>
        )}

        {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626', marginBottom:14 }}>{erro}</div>}
        <div style={{ display:'flex', flexDirection:isMobile?'column':'row', gap:10 }}>
          <button type="submit" disabled={load} style={{ flex:1, padding:14, background:'#185FA5', color:'white', border:'none', borderRadius:10, fontSize:16, cursor:'pointer', fontWeight:500 }}>
            {load?'⏳ Enviando...':'Enviar solicitação'}
          </button>
          <button type="button" onClick={() => { setTipoSel(null); setCampos([]); setDocsTipo([]) }} style={{ padding:'14px 20px', border:'1px solid #d1d5db', borderRadius:10, fontSize:14, cursor:'pointer', background:'white' }}>Cancelar</button>
        </div>
      </>}
    </form>
  )

  // DETALHE
  if(tela==='detalhe') return wrap(<>
    {processoAtivo && <>
      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
        <div style={{ fontFamily:'monospace', fontSize:13, color:'#185FA5', fontWeight:700, marginBottom:4 }}>{processoAtivo.numero}</div>
        <div style={{ fontSize:16, fontWeight:600, marginBottom:12 }}>{processoAtivo.assunto}</div>
        <span style={{ background:SBG[processoAtivo.status]||'#f3f4f6', color:SC[processoAtivo.status]||'#374151', padding:'4px 12px', borderRadius:99, fontSize:13, fontWeight:500 }}>
          {SL[processoAtivo.status]||processoAtivo.status}
        </span>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginTop:14 }}>
          {[['Aberto em',new Date(processoAtivo.aberto_em).toLocaleDateString('pt-BR')],['Setor',processoAtivo.setor_atual_nome||'—'],['Prazo',processoAtivo.prazo_em?new Date(processoAtivo.prazo_em).toLocaleDateString('pt-BR'):'—'],['Tipo',processoAtivo.tipo_nome||'—']].map(([l,v])=>(
            <div key={l}><div style={{ fontSize:11, color:'#9ca3af' }}>{l}</div><div style={{ fontSize:13, fontWeight:500, marginTop:1 }}>{v}</div></div>
          ))}
        </div>
      </div>
      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        <div style={{ display:'flex', borderBottom:'1px solid #f3f4f6' }}>
          {[{key:'andamento',label:'Andamento'},{key:'documentos',label:`Docs${docs.length>0?` (${docs.length})`:''}`}].map(a=>(
            <div key={a.key} onClick={()=>setAbaDetalhe(a.key)} style={{ flex:1, padding:'14px 16px', textAlign:'center', fontSize:14, cursor:'pointer', fontWeight:abaDetalhe===a.key?500:400, color:abaDetalhe===a.key?'#185FA5':'#9ca3af', borderBottom:abaDetalhe===a.key?'2px solid #185FA5':'2px solid transparent' }}>{a.label}</div>
          ))}
        </div>
        <div style={{ padding:16 }}>
          {abaDetalhe==='andamento' && (
            (!processoAtivo.tramitacoes||processoAtivo.tramitacoes.length===0)
              ? <div style={{ textAlign:'center', padding:24, color:'#9ca3af', fontSize:14 }}>Nenhum andamento ainda.</div>
              : processoAtivo.tramitacoes?.map((t,i,arr)=>(
                <div key={i} style={{ display:'flex', gap:12, paddingBottom:16, position:'relative' }}>
                  {i<arr.length-1&&<div style={{ position:'absolute', left:14, top:30, bottom:0, width:2, background:'#e5e7eb' }} />}
                  <div style={{ width:28, height:28, borderRadius:'50%', background:'#E6F1FB', border:'2px solid #B5D4F4', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, flexShrink:0 }}>{IT[t.tipo]||'📋'}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:14, lineHeight:1.5 }}>{t.descricao}</div>
                    <div style={{ fontSize:12, color:'#9ca3af', marginTop:4 }}>{new Date(t.data_hora).toLocaleString('pt-BR')}</div>
                  </div>
                </div>
              ))
          )}
          {abaDetalhe==='documentos' && (
            docs.length===0
              ? <div style={{ textAlign:'center', padding:24, color:'#9ca3af', fontSize:14 }}>Nenhum documento enviado.</div>
              : docs.map((d,i)=>(
                <div key={d.id||i} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 0', borderBottom:'1px solid #f9fafb' }}>
                  <span style={{ fontSize:24 }}>{d.nome_original?.toLowerCase().endsWith('.pdf')?'📄':'🖼'}</span>
                  <div style={{ flex:1 }}><div style={{ fontSize:14 }}>{d.nome_original}</div></div>
                </div>
              ))
          )}
        </div>
      </div>
    </>}
  </>)

  // HOME
  const pendentes = processos.filter(p=>p.status==='pendente').length
  return wrap(<>
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
      <div>
        <div style={{ fontSize:16, fontWeight:500 }}>Olá, {servidor?.nome?.split(' ')[0]}!</div>
        <div style={{ fontSize:12, color:'#9ca3af' }}>Suas solicitações internas</div>
      </div>
      <button onClick={() => { setTela('novo'); setErro(''); setTipoSel(null) }} style={{ padding:'10px 16px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:14, cursor:'pointer', fontWeight:500 }}>
        + Nova
      </button>
    </div>
    {pendentes > 0 && (
      <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:10, padding:'12px 14px', marginBottom:16 }}>
        <div style={{ fontSize:13, color:'#854d0e' }}>⚠️ <strong>{pendentes}</strong> solicitaç{pendentes>1?'ões':'ão'} com documentos pendentes.</div>
      </div>
    )}
    <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
      {processos.length===0
        ? <div style={{ padding:40, textAlign:'center' }}>
            <div style={{ fontSize:40, marginBottom:12 }}>📋</div>
            <div style={{ fontSize:15, fontWeight:500, marginBottom:8 }}>Nenhuma solicitação ainda</div>
            <button onClick={() => setTela('novo')} style={{ padding:'12px 24px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:14, cursor:'pointer' }}>+ Fazer solicitação</button>
          </div>
        : processos.map((p,i)=>(
          <div key={p.id} onClick={() => verDetalhe(p)} style={{ display:'flex', alignItems:'center', gap:12, padding:'16px', borderBottom:i<processos.length-1?'1px solid #f3f4f6':'none', cursor:'pointer' }}>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:14, fontWeight:500, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.assunto}</div>
              <div style={{ fontSize:12, color:'#9ca3af', marginTop:3 }}>{new Date(p.aberto_em).toLocaleDateString('pt-BR')}</div>
              <span style={{ background:SBG[p.status]||'#f3f4f6', color:SC[p.status]||'#374151', padding:'2px 8px', borderRadius:99, fontSize:11, display:'inline-block', marginTop:4 }}>{SL[p.status]||p.status}</span>
            </div>
            <span style={{ color:'#d1d5db', fontSize:20 }}>›</span>
          </div>
        ))
      }
    </div>
  </>)
}
